import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const ParticipantLayoutActiveContext = createContext(false);
const ParticipantLayoutControlsContext = createContext({
  active: false,
  onRequestClose: undefined
});

export function ParticipantLayoutActiveProvider({ active, onRequestClose, children }) {
  const activeValue = Boolean(active);
  const controlsValue = useMemo(
    () => ({
      active: activeValue,
      onRequestClose: activeValue ? onRequestClose : undefined
    }),
    [activeValue, onRequestClose]
  );

  return (
    <ParticipantLayoutActiveContext.Provider value={activeValue}>
      <ParticipantLayoutControlsContext.Provider value={controlsValue}>
        {children}
      </ParticipantLayoutControlsContext.Provider>
    </ParticipantLayoutActiveContext.Provider>
  );
}

ParticipantLayoutActiveProvider.propTypes = {
  active: PropTypes.bool,
  onRequestClose: PropTypes.func,
  children: PropTypes.node
};

export function useParticipantLayoutActive() {
  return useContext(ParticipantLayoutActiveContext);
}

export function useParticipantLayoutControls() {
  return useContext(ParticipantLayoutControlsContext);
}
